"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4628],{

/***/ 74628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PublicTour; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71418);
/* harmony import */ var _tour_BaseTour__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16304);
/* harmony import */ var _models_Tour__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40784);





var PublicTour = /*#__PURE__*/ function(BaseTour) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PublicTour, BaseTour);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PublicTour);
    function PublicTour(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, PublicTour);
        return _super.call(this, props, _models_Tour__WEBPACK_IMPORTED_MODULE_1__/* .TourType.Regular */ .v.Regular);
    }
    var _proto = PublicTour.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _props = this.props, tour = _props.tour, matterId = _props.matterId, tourData = _props.tourData;
        if (tour) {
            // preview of the tour, load from props
            this.loadData(tour);
        } else {
            this.getTour({
                id: matterId,
                tourData: tourData
            });
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.takePosition);
        document.removeEventListener("contextmenu", this.disableContext);
    };
    return PublicTour;
}(_tour_BaseTour__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);



/***/ })

}]);